import type { ICustomControlDiagnosticReportReadProps } from '../../interfaces/customControlDiagnosticReportReadProps';
import { getServiceLabel } from '../../../../../../common/customControls/getServiceLabel';
import { GradingSummary } from '../../../../../../common/enums/gradingSummary';
import { getDisplayName } from '../../../../../../common/utils/getDisplayName';
import { translateKey } from '../../../../../translate';
import { DiagnosticReportReadButtons } from '../../../../elements/carePathButtons/DiagnosticReportReadButtons';
import { FormDivider, UserTextParagraph } from '../../../../elements/common';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../elements/forms/InputContainer';
import { ProcessContainer } from '../../../episodes/common';
import { ProcessItemFooter } from '../../../episodes/ProcessItemFooter';
import { ProcessItemHeader } from '../../../episodes/ProcessItemHeader';
import { showAfwijkingen } from '../../TCCr/v1/CardioAfwijkingen';
import { CustomControlCollapseBody } from '../../utils/v1/CustomControlCollapseBody';
import { TiecgV1DiagnosticReportReadCustomControlFields } from './TiecgV1DiagnosticReportReadCustomControlFields';
import { TiecgV1DiagnosticReportSummary } from './TiecgV1DiagnosticReportSummary';

export function TiecgV1DiagnosticReportRead(props: ICustomControlDiagnosticReportReadProps) {
    return (
        <ProcessContainer>
            <ProcessItemHeader
                date={props.diagnosticReport && props.diagnosticReport.dateSent}
                isFirstItem={props.isFirstItem}
                isItemOpen={props.itemState.isOpen}
                onToggle={async (isOpened) => await props.updateItemState({ ...props.itemState, isOpen: isOpened })}
                organizationName={props.diagnosticReport.performerOrganization?.name}
                practitionerName={
                    props.diagnosticReport.performerPractitioner
                        ? getDisplayName(props.diagnosticReport.performerPractitioner)
                        : undefined
                }
                process={props.process}
                status={
                    props.diagnosticReport.gradingSummary === GradingSummary.deviant
                        ? translateKey('diagnosis.deviant')
                        : undefined
                }
                title={getServiceLabel(
                    props.process.code,
                    'diagnosticReport',
                    translateKey('diagnosticReport.category_examinationReport')
                )}
            />

            <TiecgV1DiagnosticReportSummary {...props} />

            <CustomControlCollapseBody isOpen={props.itemState.isOpen}>
                <FormDivider />

                <TiecgV1DiagnosticReportReadCustomControlFields
                    customControlData={props.diagnosticReport.customControlData}
                    remark={props.diagnosticReport.remark || null}
                    txcsProcesId={props.request.txcsProcesId}
                />

                {props.diagnosticReport.remark && (
                    <HorizontalFormGroupRead>
                        <FormLabel>{translateKey('diagnosticReport.generalRemark')}</FormLabel>
                        <InputContainer>
                            <UserTextParagraph>{props.diagnosticReport.remark}</UserTextParagraph>
                        </InputContainer>
                    </HorizontalFormGroupRead>
                )}
            </CustomControlCollapseBody>

            {checkIsFooterVisible() && (
                <ProcessItemFooter
                    isItemOpen={props.itemState.isOpen}
                    labelLess={translateKey('diagnosticReport.hideExaminationReport')}
                    labelMore={translateKey('diagnosticReport.showExaminationReport')}
                    onToggle={async (isOpened) => await props.updateItemState({ ...props.itemState, isOpen: isOpened })}
                />
            )}
            {props.processButtons ? <>{props.processButtons} </> : <DiagnosticReportReadButtons {...props} />}
        </ProcessContainer>
    );

    function checkIsFooterVisible() {
        const customControlData = props.diagnosticReport.customControlData;

        return Boolean(
            props.diagnosticReport.remark ||
                customControlData.essentiele_veranderingen_in_het_ritme_geleiding_of_ST ||
                customControlData.veranderingen_in_het_ECG_ritme ||
                customControlData.toelichting ||
                customControlData.hartfrequentierespons_op_inspanning_is ||
                customControlData.bloeddruk_response ||
                showAfwijkingen(
                    props.process.txcsProcesId,
                    props.diagnosticReport.customControlData,
                    'conclusie_rust_ecg'
                )
        );
    }
}
